import { render, staticRenderFns } from "./SelectVehicleTable.vue?vue&type=template&id=482a53ba&"
import script from "./SelectVehicleTable.vue?vue&type=script&lang=js&"
export * from "./SelectVehicleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports